export const getAutoResponseMailText = (data) => {
  const { fullname } = data;
  return `
    ※このメールはシステムからの自動返信です

    ${fullname} 様

    お世話になっております。
    大洋紙業株式会社でございます。
    この度は、弊社サービスE-Biss Factoryについてお問い合わせいただき誠にありがとうございます。
    お問い合わせいただいた内容を確認し、後ほど担当よりご連絡させていただきますので今しばらくお待ちくださいませ。

    ———————————————————————
    大洋紙業株式会社
    住所：〒660-0807　兵庫県尼崎市長洲西通2-9-15
    電話番号：06-6415-7877
    営業時間：平日 9時～17時
    メール：info@taiyo-gr.jp
    ———————————————————————
    `;
};

export const getNotificationMailText = (data) => {
  const { fullname, company, department, email, tel, body } = data;
  return `
    ${company} ${fullname}様からのお問い合わせ

    部署名: ${department}
    メールアドレス: ${email}
    電話番号: ${tel}
    本文:
    ${body}

    担当者の方はお問い合わせ内容を確認の上、記載のメールアドレスに回答をお願いいたします。
  `;
};
